var exports = {
  "Zd": "AddFriendForm.module__form___SUthM3",
  "kL": "AddFriendForm.module__container___SUthM3",
  "QX": "AddFriendForm.module__containerDesktop___SUthM3",
  "hF": "AddFriendForm.module__input___SUthM3",
  "Rq": "AddFriendForm.module__inputDesktop___SUthM3",
  "Xu": "AddFriendForm.module__inputError___SUthM3",
  "x6": "AddFriendForm.module__button___SUthM3",
  "oR": "AddFriendForm.module__inlineButton___SUthM3",
  "gJ": "AddFriendForm.module__errorMessage___SUthM3",
  "Jl": "AddFriendForm.module__successMessage___SUthM3",
};

module.exports = exports;
